export const existLetter = (str: string) => {
    return str.split("").some((char) => isNaN(parseInt(char))); // essa função verifica se existe alguma letra na string passada e se existir retorna true
  };